const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/ErrorBoundary/ErrorDlg.tsx';
import { useIntl } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';

import { IActionBtn } from './ErrorBoundary';
import textMap from './translations';

/**
 * React props
 */
export interface IErrorDlgProps {
    msg: string;
    isOpen: boolean;
    actionBtns?: IActionBtn[];
    closeDlg: () => void;
}

/**
 * Functional React component
 */
export const ErrorDlg = (props: IErrorDlgProps) => {
    const { formatMessage } = useIntl();
    const btns = (() => {
        if (!props.actionBtns || !props.actionBtns.length) {
            return (
                <Button color="primary" variant="text" onClick={props.closeDlg}>
                    {formatMessage(textMap.okBtn)}
                </Button>
            );
        } else {
            const btns = props.actionBtns.map((actionBtn: IActionBtn, idx: number) => {
                const onClick = () => {
                    props.closeDlg();
                    actionBtn.onClick();
                };
                return (
                    <Button key={idx} color="primary" variant="text" onClick={onClick}>
                        {actionBtn.label}
                    </Button>
                );
            });
            return <>{btns}</>;
        }
    })();
    return (
        <Dialog open={props.isOpen} onClose={props.closeDlg}>
            <DialogContent>
                <DialogContentText>{props.msg}</DialogContentText>
            </DialogContent>
            <DialogActions>{btns}</DialogActions>
        </Dialog>
    );
};
